export const isInternalNetwork = (): boolean => {
  return (
    location.origin.indexOf('hexin.im') > 0 ||
    location.origin.indexOf('localhost') > 0 ||
    location.origin.indexOf('192.') > 0
  )
}

/**
 * 根据当前协议获取适当的URL前缀
 * @param {string} internalDomain 内部环境域名
 * @param {string} externalDomain 外部环境域名
 * @param {string} path API路径
 * @returns {string} 完整的API基础URL
 */
export const getUrlWithCurrentProtocol = (
  internalDomain: string,
  externalDomain: string,
  path: string = '/api',
): string => {
  // 获取当前页面协议
  const protocol = location.protocol
  // 根据环境选择合适的域名
  const domain = isInternalNetwork() ? internalDomain : externalDomain
  // 构建基础URL
  return `${protocol}//${domain}${path}`
}

export const getApiUrl = (baseUrl: string, url: string) => {
  const protocol = location.protocol
  return `${protocol}//${baseUrl}${url}`
}

//
export const getUCUrl = (url: string) => {
  const baseUrl = getUrlWithCurrentProtocol('uc.hexin.im', 'uc.hexinedu.com', '/api')
  return baseUrl + url
}

export const getThemisUrl = (url: string) => {
  const baseUrl = getUrlWithCurrentProtocol('themis.hexin.im', 'themis.hexinedu.com', '/api/admin')
  return baseUrl + url
}

export const getFounderUrl = (url: string) => {
  const baseUrl = getUrlWithCurrentProtocol('founder.hexin.im', 'founder.hexinedu.com', '/api')
  return baseUrl + url
}

export const getProdPublishUrl = (url: string) => {
  const baseUrl = 'publish.hexinedu.com/api'
  return getApiUrl(baseUrl, url)
}

export const getWorksheetUrl = (url: string) => {
  const baseUrl = 'worksheet.hexinedu.com/api'
  return getApiUrl(baseUrl, url)
}

export const getEnvPublishUrl = (url: string, env: string) => {
  const baseUrl = env === 'production' ? 'publish.hexinedu.com/api' : 'publish.hexin.im/api'
  return getApiUrl(baseUrl, url)
}

export const getPptUrl = (url: string) => {
  const baseUrl = 'ppt.hexinedu.com/api'
  return getApiUrl(baseUrl, url)
}
